import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Sidebar } from '../../Components/Sidebar'
import { AddConsentForm } from '../../Components/Consent/AddConsentForm'

export const EditConsent = () => {
    return (
        <Container fluid className='p-4'>
            <Row>
                <Col md={3}>
                    <Sidebar
                        title={'Manage Old Consent'}
                        subTitle={'Enter company details '}
                        ctaText={'Need help to generate new consent?'}
                    />
                </Col>
                <Col md={7} className='offset-1 mt-4'>
                    <AddConsentForm />
                </Col>
            </Row>
        </Container>
    )
}
